var _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3408 2.1037C11.7333 1.96543 12.1661 1.96543 12.5687 2.1037L19.2014 4.32867C19.9462 4.57382 20.4495 5.26122 20.4495 6.02608L20.4999 12.6637C20.5099 14.674 19.7751 16.6253 18.4264 18.1561C17.8125 18.8621 17.0174 19.4603 16.0109 19.9996L12.4379 21.9117C12.3272 21.9706 12.2064 22 12.0856 22C11.9648 22 11.834 21.9706 11.7233 21.9117L8.12005 20.0486C7.1035 19.5191 6.30838 18.9307 5.68436 18.2345C4.31554 16.7244 3.55062 14.773 3.54055 12.7628L3.50014 6.12316C3.49023 5.3583 3.99347 4.67286 4.7282 4.41693L11.3408 2.1037Z",
    fill: "#2666FA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 8.5,
    width: 2,
    height: 6,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 12.5,
    width: 2,
    height: 6,
    transform: "rotate(-90 9 12.5)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ec103854599a2f09352bd641651806e8.svg";
export { ForwardRef as ReactComponent };